export default "__VITE_ASSET__CT$DkW2j__"